import FmdBadRoundedIcon from '@mui/icons-material/FmdBadRounded';
import { Box } from '@mui/material';
import React from 'react';
import BolIcon from '../../svg-icons/BolIcon.jsx';
import BricoMarcheIcon from '../../svg-icons/BricoMarcheIcon.jsx';
import CarrefourIcon from '../../svg-icons/CarrefourIcon.jsx';
import CasanoovLogo from '../../svg-icons/CasanoovLogo';
import CasanoovProLogo from '../../svg-icons/CasanoovProLogo';
import CazebooLogo from '../../svg-icons/CazebooLogo';
import MaisonsDuMondeIcon from '../../svg-icons/MaisonsDuMondeIcon.jsx';
import MPAllegroIcon from '../../svg-icons/MPAllegroIcon';
import MPAmazonIcon from '../../svg-icons/MPAmazonIcon';
import MPBricodepotIcon from '../../svg-icons/MPBricodepotIcon';
import MPButIcon from '../../svg-icons/MPButIcon';
import MPCDiscountIcon from '../../svg-icons/MPCDiscountIcon';
import MPEpriceIcon from '../../svg-icons/MPEpriceIcon';
import MPHome24Icon from '../../svg-icons/MPHome24Icon';
import MPKauflandIcon from '../../svg-icons/MPKauflandIcon';
import MPLeclercIcon from '../../svg-icons/MPLeclercIcon';
import MPLeroymerlinIcon from '../../svg-icons/MPLeroymerlinIcon';
import MPManomanoIcon from '../../svg-icons/MPManomanoIcon';
import MPObiIcon from '../../svg-icons/MPObiIcon';
import MPWortenIcon from '../../svg-icons/MPWortenIcon';
import SicaanLogo from '../../svg-icons/SicaanLogo';
import TeractIcon from '../../svg-icons/TeractIcon.jsx';
import TiktokShopIcon from '../../svg-icons/TiktokShopIcon.jsx';
import ErrorBoundary from '../errors/ErrorBoundary';
import InternalServerError from '../errors/InternalServerError.jsx';

const selectBrandLogo = (props) => {
  const { brand, type } = props;
  switch (brand) {
    case 'Casanoov':
      return type === 'C' ? (
        <CasanoovLogo {...props} />
      ) : (
        <CasanoovProLogo {...props} />
      );
    case 'Cazeboo':
      return <CazebooLogo {...props} />;
    case 'Sicaan':
      return <SicaanLogo {...props} />;
    case 'Allegro':
      return <MPAllegroIcon {...props} />;
    case 'ePrice':
      return <MPEpriceIcon {...props} />;
    case 'LeroyMerlin':
      return <MPLeroymerlinIcon {...props} />;
    case 'Kaufland':
      return <MPKauflandIcon {...props} />;
    case 'Worten':
      return <MPWortenIcon {...props} />;
    case 'Bricodepot':
      return <MPBricodepotIcon {...props} />;
    case 'Leclerc':
      return <MPLeclercIcon {...props} />;
    case 'Home24':
      return <MPHome24Icon {...props} />;
    case 'Amazon':
      return <MPAmazonIcon {...props} />;
    case 'But':
      return <MPButIcon {...props} />;
    case 'CDiscount':
      return <MPCDiscountIcon {...props} />;
    case 'ManoMano':
      return <MPManomanoIcon {...props} />;
    case 'OBI':
      return <MPObiIcon {...props} />;
    case 'Carrefour':
      return <CarrefourIcon {...props} />;
    case 'Teract':
      return <TeractIcon {...props} />;
    case 'TikTokShop':
      return <TiktokShopIcon {...props} />;
    case 'BricoMarche':
      return <BricoMarcheIcon {...props} />;
    case 'Bol':
      return <BolIcon {...props} />;
    case 'Maisons du Monde':
      return <MaisonsDuMondeIcon {...props} />;
    default: // Unknown / Bricoman / Brico / Praxis / Hornbach
      return <FmdBadRoundedIcon {...props} />;
  }
};

const BrandLogo = (props) => {
  const { brand } = props;

  return (
    <ErrorBoundary fallback={<InternalServerError />} source="BrandLogo">
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        {brand ? selectBrandLogo(props) : null}
      </Box>
    </ErrorBoundary>
  );
};

export default BrandLogo;
